import Layout from '@/layout/base/layoutSegfy'

// "Mensagem" é o item de menu que vem da auth (chave SEGFY_MENSAGEM, link
// /mensagem). Enquanto o usuário não dispensa a apresentação, o clique no menu
// cai aqui e mostra a apresentação do produto dentro do Gestão; depois, o menu abre
// o produto direto em aba nova — ver components/mensagem/abrir.vue.
export default [{
  path: '/mensagem',
  component: Layout,
  children: [{
    path: '',
    name: 'mensagem',
    component: () => import('@/components/mensagem/abrir'),
    meta: {
      auth: true
    }
  }]
}]
